import { Form, Modal, Input, Select, Button, InputNumber } from "antd";
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { getDirectusClient } from "../../../lib/directus";
import { updateItem, readItems, readUsers } from "@directus/sdk";

const { Option } = Select;

function EditDescuento({
  openedit,
  editModal,
  getDescuentos,
  descuentoSelect,
}) {
  const [form] = Form.useForm();
  const [usuarios, setUsuarios] = useState([]);
  const [productos, setProductos] = useState([]);
  const [loadingUsers, setLoadingUsers] = useState(false);
  const userBodega = useSelector((state) => state.userdata.bodega?.id);

  const getUsuarios = async () => {
    setLoadingUsers(true);
    const directus = await getDirectusClient();
    try {
      const response = await directus.request(
        readUsers({
          fields: ["id", "first_name", "last_name", "role.name", "bodega.id"],
          filter: {
            _and: [
              {
                _and: [
                  {
                    role: {
                      name: {
                        _ncontains: "Administrador",
                      },
                    },
                  },
                  {
                    role: {
                      name: {
                        _ncontains: "Administrator",
                      },
                    },
                  },
                  {
                    role: {
                      name: {
                        _ncontains: "adminapp",
                      },
                    },
                  },
                ],
              },
              {
                bodega: {
                  id: {
                    _eq: userBodega,
                  },
                },
              },
            ],
          },
          sort: ["first_name"],
        })
      );

      // Additional safety filter
      const validUsers = response.filter(
        (user) =>
          user.first_name &&
          !user.role?.name?.includes("Administrador") &&
          !user.role?.name?.includes("Administrator")
      );

      setUsuarios(validUsers);
    } catch (err) {
      console.error("Error fetching users:", err);
    } finally {
      setLoadingUsers(false);
    }
  };

  const getProductos = async () => {
    const directus = await getDirectusClient();
    try {
      const response = await directus.request(
        readItems("productos", {
          fields: ["*", "nombre", "id", "grupo.*", "referencia"],
        })
      );
      console.log("Products response:", response);
      setProductos(response);
    } catch (err) {
      console.error("Error fetching products:", err);
    }
  };

  useEffect(() => {
    if (userBodega) {
      getUsuarios();
      getProductos();
    }
  }, [userBodega]);

  useEffect(() => {
    if (descuentoSelect) {
      console.log("Setting form values with:", descuentoSelect);
      const usuarios = Array.isArray(descuentoSelect.usuarios)
        ? descuentoSelect.usuarios.map((u) => u.directus_users_id?.id)
        : [];

      const productos = descuentoSelect.productos
        ? Array.isArray(descuentoSelect.productos)
          ? descuentoSelect.productos.map((p) => p.id)
          : [descuentoSelect.productos.id]
        : [];

      form.setFieldsValue({
        nombre: descuentoSelect.nombre,
        descuento: descuentoSelect.descuento,
        usuarios: usuarios,
        productos: productos,
      });
    }
  }, [descuentoSelect, form]);

  const onFinish = async (values) => {
    const directus = await getDirectusClient();
    directus
      .request(
        updateItem("descuentos", descuentoSelect.id, {
          nombre: values.nombre,
          descuento: values.descuento,
          usuarios: values.usuarios.map((userId) => ({
            directus_users_id: { id: userId },
          })),
          productos: values.productos
            ? values.productos.map((productId) => ({ id: productId }))
            : [],
        })
      )
      .then(() => {
        getDescuentos();
        editModal();
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const onReset = () => {
    form.resetFields();
  };

  return (
    <Modal
      title="Editar Descuento"
      open={openedit}
      onCancel={editModal}
      footer={false}
    >
      <Form
        form={form}
        name="control-hooks"
        onFinish={onFinish}
        style={{
          maxWidth: 600,
        }}
      >
        <Form.Item
          name="nombre"
          label="Nombre"
          rules={[
            {
              required: true,
              message: "Por favor ingrese el nombre del descuento",
            },
          ]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          name="descuento"
          label="Descuento (%)"
          rules={[
            {
              required: true,
              message: "Por favor ingrese el porcentaje de descuento",
            },
          ]}
        >
          <InputNumber
            min={0}
            precision={5} 
            style={{ width: "100%" }}
          />
        </Form.Item>

        <Form.Item
          name="usuarios"
          label="Usuarios"
          rules={[
            {
              required: true,
              message: "Por favor seleccione al menos un usuario",
            },
          ]}
        >
          <Select
            mode="multiple"
            placeholder="Seleccione usuarios"
            allowClear
            loading={loadingUsers}
            style={{ width: "100%" }}
            optionFilterProp="children"
            showSearch
          >
            {usuarios.map((usuario) => (
              <Option
                key={usuario.id}
                value={usuario.id}
                title={`${usuario.first_name} ${usuario.last_name || ""}`}
              >
                {usuario.first_name} {usuario.last_name || ""}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          name="productos"
          label="Productos"
          rules={[
            {
              required: true,
              message: "Por favor seleccione un producto",
            },
          ]}
        >
          <Select
            placeholder="Seleccione productos"
            allowClear
            style={{ width: "100%" }}
          >
            {productos.map((producto) => (
              <Option key={producto.id} value={producto.id}>
                {producto.nombre}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item>
          <Button type="primary" htmlType="submit">
            Guardar
          </Button>
          <Button htmlType="button" onClick={onReset} style={{ marginLeft: 8 }}>
            Limpiar
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
}

EditDescuento.propTypes = {
  openedit: PropTypes.bool.isRequired,
  editModal: PropTypes.func.isRequired,
  getDescuentos: PropTypes.func.isRequired,
  descuentoSelect: PropTypes.shape({
    id: PropTypes.number.isRequired,
    nombre: PropTypes.string.isRequired,
    descuento: PropTypes.number.isRequired,
    usuarios: PropTypes.arrayOf(
      PropTypes.shape({
        directus_users_id: PropTypes.shape({
          id: PropTypes.string.isRequired,
          first_name: PropTypes.string,
          last_name: PropTypes.string,
        }),
      })
    ),
    productos: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string.isRequired,
        nombre: PropTypes.string,
        referencia: PropTypes.string,
        grupo: PropTypes.object,
      })
    ),
  }).isRequired,
};

export default EditDescuento;
